import { ReclaimFlagKey } from "@redotech/feature-flags-keys-reclaim/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useQuery } from "@tanstack/react-query";

export interface DisputeAlertsEnrollmentEnabledState {
  readonly pending: boolean;
  readonly enabled: boolean;
}

/**
 * Feature flag for the internal dispute-alert enrollment UI (the finance-nav
 * "Alerts" tab). Reads the DISPUTE_ALERTS_UI LaunchDarkly flag scoped
 * to the current team. Defaults to `false` while `pending` and when LD is
 * unreachable, so the nav item stays hidden until the flag resolves on.
 */
export function useDisputeAlertsEnrollmentEnabled(): DisputeAlertsEnrollmentEnabledState {
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );
  const team = useRequiredContext(TeamContext);
  const teamId = String(team._id);

  const query = useQuery({
    queryKey: ["featureFlag", ReclaimFlagKey.DISPUTE_ALERTS_UI, teamId],
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({
        flagKey: ReclaimFlagKey.DISPUTE_ALERTS_UI,
      });
      return response.enabled;
    },
    staleTime: Infinity,
  });

  return { pending: query.isPending, enabled: query.data ?? false };
}
